module.exports = __webpack_public_path__ + "static/img/lifestyle_37.1efa0eca.png";